import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import UpperProgressBar from "../components/common-components/UpperProgressBar";
import RightSidebar from "../components/common-components/right_sidebar";
import hospitalServices from "../services/hospital.services";
import { useNavigate } from "react-router-dom";
import LoadingBar from "../components/common-components/toaster/loader/loader";
import HospitalInfoCard from "../components/hospitalInfoCard/HospitalInfoCard";
const HospitalInfo = () => {
    const navigate = useNavigate()
    const [departmentsList, setDepartmentList] = useState([])
    const [Fieldval, SetFieldVal] = useState({})
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        hospitalServices.getDepartMents()
            .then(resp => setDepartmentList(resp.data))
            .catch(err => console.log(err))
    }, [])

    return (
        <div className="signup_pg">
            <Container fluid>
                {loading &&
                    <LoadingBar />}
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <UpperProgressBar step={3} />
                            <div className="signup_form">

                            <HospitalInfoCard edit={false}/>
                            </div>
                        </Col>
                        <RightSidebar step={3} />
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default HospitalInfo;
